import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 686.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,686.000000) scale(0.100000,-0.100000)">

<path d="M5125 5309 c-156 -12 -354 -52 -480 -97 -16 -6 -57 -19 -90 -28 -59
-16 -119 -44 -301 -141 -138 -73 -189 -105 -242 -154 -27 -24 -65 -53 -85 -64
-42 -23 -187 -160 -187 -176 0 -11 187 -210 203 -218 5 -1 29 18 54 44 26 25
67 63 92 83 25 20 63 51 84 70 21 18 48 37 60 43 12 5 45 23 72 40 28 16 65
36 84 45 18 8 45 24 60 35 14 10 62 32 107 48 44 15 94 36 112 45 17 9 37 16
43 16 7 0 20 6 28 14 21 18 172 53 341 78 233 34 509 17 760 -47 36 -9 69 -21
74 -26 6 -5 19 -9 31 -9 11 0 45 -9 75 -21 30 -11 71 -26 90 -32 19 -6 62 -28
96 -48 33 -20 97 -56 142 -79 45 -23 89 -51 98 -61 9 -11 22 -19 29 -19 13 0
128 -93 200 -162 28 -26 55 -48 60 -48 10 0 225 204 225 214 0 15 -309 258
-349 274 -7 3 -30 20 -50 38 -20 19 -50 41 -68 49 -17 8 -58 30 -90 48 -32 19
-68 36 -78 40 -11 3 -54 20 -95 37 -116 49 -232 85 -385 120 -262 58 -436 70
-720 49z"/>
<path d="M5180 4693 c-110 -18 -253 -47 -290 -58 -25 -8 -67 -22 -95 -31 -66
-20 -267 -114 -281 -131 -6 -7 -16 -13 -21 -13 -30 0 -313 -225 -313 -250 0
-13 191 -210 204 -210 7 0 41 25 77 56 35 31 82 67 104 81 22 14 59 38 83 55
59 41 216 113 282 129 30 7 60 16 65 20 6 4 72 17 148 30 130 21 148 22 283
11 135 -11 211 -24 259 -42 11 -5 45 -16 75 -26 30 -10 59 -22 65 -26 5 -4 18
-8 28 -8 19 0 137 -55 147 -69 3 -3 18 -12 35 -20 39 -17 134 -85 201 -143 30
-27 58 -48 63 -48 6 0 38 30 73 67 35 36 80 83 102 104 21 21 36 42 35 46 -2
5 -38 40 -80 78 -80 73 -175 138 -294 200 -38 20 -74 40 -80 45 -5 4 -30 15
-55 24 -25 8 -76 27 -115 41 -38 14 -95 28 -124 32 -30 3 -66 12 -80 20 -15 7
-38 13 -52 13 -14 0 -48 7 -75 15 -46 14 -304 20 -374 8z"/>
<path d="M6650 3915 c-101 -101 -181 -188 -176 -192 4 -4 40 -6 81 -4 66 2 75
1 85 -18 8 -15 9 -87 4 -249 -4 -126 -4 -245 0 -265 l7 -37 194 0 c107 0 194
3 194 8 -1 4 -1 130 0 280 l1 272 78 0 c42 0 83 4 91 9 11 7 -30 54 -172 195
-102 102 -189 186 -194 186 -4 0 -91 -83 -193 -185z"/>
<path d="M5170 4065 c-88 -14 -175 -38 -194 -54 -6 -5 -36 -19 -66 -32 -62
-26 -181 -102 -252 -162 l-47 -39 27 -37 c15 -20 34 -40 42 -45 8 -5 42 -38
76 -73 33 -35 65 -63 71 -63 5 0 32 19 59 43 28 24 77 56 110 72 32 15 71 34
85 41 57 29 145 44 256 44 196 0 360 -59 480 -173 50 -48 41 -53 161 87 l86
99 -59 54 c-33 29 -62 53 -66 53 -3 0 -20 14 -37 30 -18 17 -37 30 -44 30 -6
0 -19 6 -27 14 -9 8 -47 25 -86 39 -38 14 -101 37 -140 52 -62 24 -86 28 -210
31 -88 2 -171 -2 -225 -11z"/>
<path d="M6105 3568 c-3 -7 -6 -134 -7 -283 l-3 -270 -94 -3 -95 -3 110 -107
c61 -59 150 -146 200 -194 l89 -87 183 179 c101 98 187 180 192 182 5 2 10 9
12 17 2 11 -12 13 -70 12 -123 -4 -112 -33 -112 290 l0 279 -200 0 c-151 0
-202 -3 -205 -12z"/>
<path d="M5239 3386 c-65 -14 -100 -34 -150 -85 -113 -118 -147 -294 -82 -425
33 -65 114 -143 183 -175 78 -36 173 -40 271 -11 63 19 82 30 131 77 35 35 67
79 85 117 25 56 28 71 28 173 -1 103 -2 114 -26 147 -117 164 -256 222 -440
182z"/>
<path d="M5960 2050 l0 -310 1048 2 1047 3 0 305 0 305 -1047 3 -1048 2 0
-310z m420 236 c80 -28 131 -112 132 -219 0 -88 -19 -145 -67 -193 -53 -53
-99 -64 -265 -64 l-131 0 13 23 c15 25 19 368 5 427 l-8 35 148 0 c81 0 159
-4 173 -9z m515 -13 c62 -66 130 -254 142 -390 l6 -73 -79 0 -79 0 3 50 c2 28
1 62 -2 75 -6 24 -9 25 -90 25 -96 0 -96 0 -96 -91 l0 -59 -75 0 -75 0 0 48
c0 96 62 254 119 306 12 11 21 23 21 27 0 8 -58 4 -87 -6 -17 -6 -17 -3 14 60
l27 55 113 0 c109 0 113 -1 138 -27z m611 9 c-3 -9 -10 -36 -15 -58 -13 -47
-26 -54 -109 -54 l-53 0 3 -162 c2 -90 7 -171 12 -180 7 -17 0 -18 -89 -18
-89 0 -96 1 -89 18 5 9 10 91 12 182 l3 165 -89 -3 -90 -4 21 61 c18 49 26 61
47 64 14 2 119 5 233 5 190 1 208 -1 203 -16z m326 -25 c66 -90 118 -239 132
-379 l7 -68 -82 0 -82 0 6 34 c3 19 3 52 0 75 l-6 41 -88 0 -89 0 0 -75 0 -75
-75 0 -75 0 0 60 c0 95 40 199 113 293 16 20 25 37 20 37 -4 -1 -27 -5 -50 -9
-25 -5 -43 -5 -43 1 0 5 11 31 25 57 l24 49 116 1 115 0 32 -42z"/>
<path d="M6233 2174 c-10 -4 -13 -39 -13 -126 l0 -121 51 6 c61 7 74 17 90 64
16 51 6 120 -22 148 -24 23 -82 39 -106 29z"/>
<path d="M6793 2164 c-11 -16 -28 -44 -37 -61 l-17 -33 51 0 c27 0 53 1 57 3
11 3 4 35 -16 81 l-17 40 -21 -30z"/>
<path d="M7708 2152 c-14 -20 -28 -47 -32 -59 -6 -20 -3 -21 49 -25 50 -3 55
-1 55 17 0 20 -35 105 -43 105 -2 0 -16 -17 -29 -38z"/>
<path d="M4083 2289 c-44 -13 -89 -61 -97 -104 -10 -53 23 -104 101 -157 60
-41 83 -74 68 -97 -9 -16 -80 -13 -122 4 -20 8 -37 14 -39 12 -2 -1 -4 -27 -6
-57 -3 -49 -1 -55 22 -67 40 -21 183 -17 228 6 53 27 76 74 70 140 -6 61 -20
78 -110 138 -38 25 -68 51 -68 59 0 26 46 35 93 19 23 -8 45 -15 48 -15 6 0
29 78 29 99 0 26 -148 40 -217 20z"/>
<path d="M5598 2292 l-226 -2 -20 -59 -20 -60 90 6 89 6 -3 -169 c-2 -93 -7
-177 -12 -186 -7 -17 0 -18 84 -18 84 0 91 1 84 18 -5 9 -10 92 -12 185 l-3
167 75 0 75 0 17 56 c9 30 14 56 12 57 -1 1 -105 1 -230 -1z"/>
<path d="M2947 2246 c21 -24 64 -90 96 -145 l59 -102 -28 -37 c-16 -20 -53
-63 -84 -96 l-55 -58 93 3 c93 4 94 4 122 39 16 19 68 103 116 185 47 83 102
174 120 203 l34 52 -90 0 c-79 0 -90 -2 -90 -17 -1 -10 -15 -46 -33 -81 l-33
-62 -32 56 c-18 31 -35 67 -38 80 -6 23 -9 24 -101 24 l-95 0 39 -44z"/>
<path d="M3446 2276 c3 -8 -2 -59 -10 -114 -19 -116 -20 -172 -6 -224 14 -48
55 -97 98 -115 44 -18 160 -18 205 0 31 13 36 13 50 0 13 -13 24 -14 79 -3
l65 12 -19 38 c-17 34 -19 57 -16 212 2 95 7 181 12 191 7 16 0 17 -84 17 -84
0 -91 -1 -84 -17 5 -10 10 -88 12 -174 l3 -155 -26 -12 c-56 -26 -132 -9 -155
34 -19 34 -7 165 23 252 l25 72 -89 0 c-72 0 -87 -3 -83 -14z"/>
<path d="M4387 2263 c11 -38 10 -391 -1 -425 l-8 -28 87 0 c86 0 87 0 80 23
-11 31 -18 277 -8 277 4 0 59 -68 122 -151 l115 -150 58 3 59 3 2 220 c1 121
6 228 11 238 7 15 1 17 -79 17 -79 0 -86 -2 -79 -17 4 -10 9 -72 11 -138 l3
-120 -25 30 c-14 17 -63 78 -108 137 l-82 107 -83 1 -82 0 7 -27z"/>
<path d="M4992 2268 c14 -26 19 -386 5 -428 l-8 -26 150 -2 c82 -2 151 1 154
5 3 4 8 31 12 58 l6 51 -83 -1 -83 0 -3 43 -3 42 55 0 56 0 0 55 0 55 -55 0
c-54 0 -55 0 -55 30 0 28 3 30 38 31 20 1 52 0 70 -1 l32 -2 0 56 0 56 -150 0
-151 0 13 -22z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
